module.exports = __webpack_public_path__ + "static/media/nB1FBBqfLx.471d9f94.jpg";